var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIkoroduDatingLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2019,
    height: 1628,
    viewBox: "0 0 2019 1628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1627.86 34.835C1375.13 -106.622 1217.78 212.658 1138.16 455.803H880.383C800.76 212.658 643.411 -106.622 390.686 34.835C0 253.509 0 1566.41 0 1566.41C0 1566.41 130.229 1567.8 195.343 1367.4C187.875 1473.37 224.364 1560.2 260.457 1627.86C347.511 1592.97 419.556 1482.38 488.358 1362.36C496.017 1403.36 517.716 1463.94 534.345 1495.11C625.26 1458.67 717.886 1365.56 787.863 1237.18H1230.69C1300.66 1365.56 1393.29 1458.67 1484.22 1495.11C1500.85 1463.94 1522.55 1403.36 1530.21 1362.36C1599.01 1482.38 1671.06 1592.97 1758.11 1627.86C1794.21 1560.2 1830.69 1473.37 1823.23 1367.4C1888.34 1567.79 2018.57 1566.41 2018.57 1566.41C2018.57 1566.41 2018.54 253.509 1627.86 34.835Z",
    fill: "#E03368",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.14 260.461C1265.79 260.292 1199.74 279.007 1142.5 314.482C1085.25 349.957 1039.1 400.771 1009.28 461.155C979.456 400.771 933.302 349.957 876.057 314.482C818.811 279.007 752.766 260.292 685.419 260.461C486.682 260.461 325.577 419.889 325.577 616.555C325.577 1079.48 1009.28 1399.96 1009.28 1399.96C1009.28 1399.96 1692.98 1079.48 1692.98 616.555C1692.98 419.889 1531.87 260.461 1333.14 260.461Z",
    fill: "url(#paint0_linear_237_37)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_37",
    x1: 325.577,
    y1: 260.459,
    x2: 1446.4,
    y2: 1605.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF84A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E03368"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkoroduDatingLogo);
export default __webpack_public_path__ + "static/media/Ikorodu-Dating-Logo.55062afcffd35a9ded1fa5310c75151c.svg";
export { ForwardRef as ReactComponent };